if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContentInfo = this.querySelector('[id^="QuickAddInfo-"]');
        this.quickAddGallery = this.querySelector('[id^="QuickAddGallery-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);

        if (preventFocus) {
          this.openedBy = null;
        }
        super.hide();

        setTimeout(() => {
          this.cleanupContent();
        }, this.HIDE_MODAL_CLOSE_TIMEOUT);
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        const removeLoading = () => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading__spinner').classList.add('hidden');
        };

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContentInfo, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            if (this.quickAddGallery) {
              // Preload images before inserting into the DOM to prevent FOUC
              HTMLUpdateUtility.preloadImages(this.quickAddGallery.innerHTML, 1)
                .then(() => {
                  super.show(opener);

                  this.quickAddGallery.querySelectorAll('video[autoplay]').forEach((video) => {
                    video.play();
                  });
                })
                .finally(() => {
                  removeLoading();

                  // Safari fix: Force Repaint
                  setTimeout(() => {
                    const content = this.querySelector('.quick-add-modal__content');
                    content.style.display = 'none';
                    content.offsetHeight; // Trigger a reflow
                    content.style.display = '';
                  }, 10);
                });
            } else {
              super.show(opener);
              removeLoading();
            }
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContentInfo.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.preventVariantURLSwitching(productElement);
        this.setProductMediaWrapper(productElement);
      }

      setProductMediaWrapper(productElement) {
        const productMediaWrapper = productElement.querySelector('.product__media-wrapper');

        // Remove productMediaWrapper from productElement
        productMediaWrapper.parentNode.removeChild(productMediaWrapper);

        const modalCloseButton = this.querySelector('[id^="ModalClose-"]');
        const firstChild = productMediaWrapper.firstChild;
        productMediaWrapper.insertBefore(modalCloseButton, firstChild);

        // Get the outer HTML of the media wrapper
        const mediaWrapperHTML = productMediaWrapper.outerHTML;

        HTMLUpdateUtility.setInnerHTML(this.quickAddGallery, mediaWrapperHTML);

        this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false), {
          once: true,
        });
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      cleanupContent() {
        // Move the modalCloseButton back to 'quick-add-modal__content' as the first child
        const modalCloseButton = this.querySelector('[id^="ModalClose-"]');
        const modalContent = this.querySelector('.quick-add-modal__content');

        if (modalCloseButton && modalContent && modalCloseButton.parentNode !== modalContent) {
          // Remove from current parent
          modalCloseButton.parentNode.removeChild(modalCloseButton);
          // Insert as the first child of 'quick-add-modal__content'
          modalContent.insertBefore(modalCloseButton, modalContent.firstChild);
        }

        this.modalContentInfo.innerHTML = '';
        this.quickAddGallery.innerHTML = '';
      }
    },
  );
}
